import { getBlenderResourceListAPI } from "@/apis/blenderRes";
import { Card, Table, message } from "antd";
import { useEffect, useState } from "react";

//Blender资源展示
const BlenderResourceDisplay = () => {

    const [messageApi, contextHolder] = message.useMessage();

    const [resourceList, setResourceList] = useState([]);
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const response = await getBlenderResourceListAPI();
                const raw = response?.data;
                const arr = Array.isArray(raw) ? raw : (raw && typeof raw === 'object' ? [raw] : []);
                if (!cancelled) setResourceList(arr);
            } catch (error) {
                if (!cancelled) {
                    if (typeof messageApi?.info === 'function') {
                        messageApi.info('Failed to fetch resource list');
                    } else {
                        console.error('[BlenderResourceDisplay] messageApi.info not function:', messageApi);
                    }
                }
            }
        })();
        return () => { cancelled = true; };
    }, [messageApi]);

    // 运行期调试：只在开发环境输出
    if (process.env.NODE_ENV !== 'production') {
        /* eslint-disable no-console */
        console.debug('[BlenderResourceDisplay] render resourceList length=', Array.isArray(resourceList)?resourceList.length:'(not array)', 'messageApi.info type=', typeof messageApi?.info);
    }

    const columns = [
        {
            title: '资源名称',
            dataIndex: 'resourceName',
            key: 'resourceName',
        },
        {
            title: '飞机架次',
            dataIndex: 'aircraftSortie',
            key: 'aircraftSortie',
        },
        {
            title: '文件大小',
            dataIndex: 'fileSize',
            key: 'fileSize',
        },
        {
            title: '下载次数',
            dataIndex: 'downloadCount',
            key: 'downloadCount',
        },
        {
            title: '上传人',
            dataIndex: 'createUserId',
            key: 'createUserId',
        },
        {
            title: '上传时间',
            dataIndex: 'createTime',
            key: 'createTime',
        },
    ]

    return (
        <Card>
            {contextHolder}
            <Table columns={columns}  dataSource={resourceList} rowKey="id"/>
        </Card>
    )
}

export default BlenderResourceDisplay;